import BaseUrls from '../../../utils/baseUrls';

const ResourceCounts = ({ theme, resourceData }: { theme: string, resourceData: any }) => {
  const resourceUrl1 = `img/${theme}/computer.png`;
  const resourceUrl2 = `img/${theme}/networkcard.png`;
  const resourceUrl3 = `img/${theme}/node-card.png`;
  const resourceUrl4 = `img/${theme}/endpoint-workspace.png`;
  const resourceUrl5 = `img/${theme}/cloud-card.png`;

  return (
        <div className="card CardHeight">
            <h4 className="text-center mt-3">Services</h4>
            <div className="card-body my-2 mt-0">
                <div className="d-flex align-items-center mt-0">
                    <div className="col-3">
                        <img src={resourceUrl1} alt="" />
                    </div>
                    <div className="col-7 my-auto ms-4">
                        <p className="mb-0 ms-3 textDanger">
                            {' '}
                            <strong> Workspaces</strong>
                            {' '}
                        </p>
                    </div>
                    <div className="col-2 mt-3">
                        <h5>{resourceData.workspace}</h5>
                    </div>
                </div>
                <div className="d-flex mt-2">
                    <div className="col-3">
                        <img src={resourceUrl2} alt="" />
                    </div>
                    <div className="col-7 my-auto ms-4">
                        <p className="mb-0 ms-3 textDanger">
                            {' '}
                            <strong> Networks</strong>
                            {' '}
                        </p>
                    </div>
                    <div className="col-2 mt-3">
                        <h5>{resourceData.networks}</h5>
                    </div>
                </div>
                <div className="d-flex mt-2">
                    <div className="col-3">
                        <img src={resourceUrl3} alt="" />
                    </div>
                    <div className="col-7 my-auto ms-4">
                        <p className="mb-0 ms-3 textDanger">
                            {' '}
                            <strong> Nodes</strong>
                            {' '}
                        </p>
                    </div>
                    <div className="col-2 mt-3">
                        <h5>{resourceData.nodes}</h5>
                    </div>
                </div>
                {BaseUrls.sharedApiEnabled()
                    && (
                        <div className="d-flex mt-2">
                            <div className="col-3">
                                <img src={resourceUrl4} alt="" width={55} height={55} />
                            </div>
                            <div className="col-7 my-auto ms-4">
                                <p className="mb-0 ms-3 textDanger">
                                    {' '}
                                    <strong>RPC Endpoints</strong>
                                    {' '}
                                </p>
                            </div>
                            <div className="col-2 mt-3">
                                <h5>{resourceData.endpoints }</h5>
                            </div>
                        </div>
                    )}
                <div className="d-flex mt-2">
                    <div className="col-3">
                        <img src={resourceUrl5} alt="" />
                    </div>
                    <div className="col-7 my-auto ms-4">
                        <p className="mb-0 ms-3 textDanger">
                            {' '}
                            <strong> Clouds</strong>
                            {' '}
                        </p>
                    </div>
                    <div className="col-2 mt-3">
                        <h5>{resourceData.clouds}</h5>
                    </div>
                </div>
            </div>
        </div>
  );
};
export default ResourceCounts;
